import React, { FC } from 'react'
import { Container } from './StickyMobileSection.style'

interface Props {
    children: React.ReactNode
    height?: string
}

const StickyMobileSection: FC<Props> = ({ children, height }) => {
    return <Container $height={height}>{children}</Container>
}

export default StickyMobileSection
